import { ENDPOINTS } from './../../endpoints';
import { Service } from './../base';
import dynamicAxios from './../../utils/axios';
import { useMemo } from 'react';
import { EntityId } from '@restworld/utility-types';

import {
  DashboardRWMemberStats,
  DashboardHistoryActiveJP,
  DashboardWinRate,
  DashboardWorkersShortlistsSent,
  DashboardAvgJpClosingTime,
  DashboardTimeFrame,
  DashboardTimeRange,
  JobPositionBillingType,
} from './types';
import useServices from '../../hooks/useServices';

class ServiceDashboard extends Service {
  rwMemberStats(csmId?: EntityId) {
    return this.axiosInstance.get<DashboardRWMemberStats>(ENDPOINTS.dashboard.rwMemberStats, {
      params: { csm_id: csmId },
    });
  }

  historyActiveJobPositions({
    jobPositionBillingType,
    timeFrame,
    timeRange,
    csmId,
  }: {
    jobPositionBillingType: JobPositionBillingType;
    timeFrame: DashboardTimeFrame;
    timeRange: DashboardTimeRange;
    csmId?: string;
  }) {
    return this.axiosInstance.get<DashboardHistoryActiveJP>(ENDPOINTS.dashboard.historyActiveJobPositions, {
      params: {
        duration: timeRange,
        csm_id: csmId,
        time_frame: timeFrame,
        job_position_billing_type: jobPositionBillingType,
      },
    });
  }

  getAssistanceSatisfactionStatistics({
    timeFrame,
    timeRange,
    csmId,
  }: {
    timeFrame: DashboardTimeFrame;
    timeRange: DashboardTimeRange;
    csmId?: string;
  }) {
    return this.axiosInstance.get<DashboardHistoryActiveJP>(ENDPOINTS.dashboard.historyActiveJobPositions, {
      params: {
        duration: timeRange,
        csm_id: csmId,
        time_frame: timeFrame,
      },
    });
  }

  csmWinRate(csmId?: string) {
    return this.axiosInstance.get<DashboardWinRate>(ENDPOINTS.dashboard.csmWinRate, {
      params: { csm_id: csmId },
    });
  }

  workersShortlistsSent(csmId?: string) {
    return this.axiosInstance.get<DashboardWorkersShortlistsSent>(ENDPOINTS.dashboard.averageShortlistsAndWorkersSent, {
      params: { csm_id: csmId },
    });
  }

  jpAvgClosingTime(csmId?: string) {
    return this.axiosInstance.get<DashboardAvgJpClosingTime>(ENDPOINTS.dashboard.jobPositionAverageClosingTime, {
      params: { csm_id: csmId },
    });
  }
}

export function useDashboardService() {
  const { baseUrl, jwt } = useServices();
  return useMemo(() => new ServiceDashboard(dynamicAxios(baseUrl, jwt)), [baseUrl, jwt]);
}

export default useDashboardService;

export * from './types';
